import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./TrmSumSheet.css";
import { withBase, Button, ControlBox } from "components";
import moment from "moment";
import TrmSumSheetConditionBox from "./TrmSumSheetConditionBox";
import TrmSumSheetTable from "./TrmSumSheetTable";

const API = {
  LIST: {
    url: "api/v1/report/trmSumSheet/list",
    method: "post",
  },
  DOWN: {
    url: "api/v1/report/trmSumSheet/down",
    method: "post",
  },
  DOWNMONTH: {
    url: "api/v1/report/trmSumSheet/downmonth",
    method: "post",
  },
};

const TrmSumSheet = (props) => {
  const [param, setParam] = useState({
    setlDate: moment().add(-1, "days").format("YYYYMMDD"),
  });
  const [datas, setDatas] = useState([]);
  const [totalData, setTotalData] = useState([]);

  useEffect(() => {
    list();
  }, [param]);

  const list = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const { url, method } = API.LIST;
    console.log(param);
    const response = await HttpRequest.request(url, method, param);
    if (HttpRequest.hasError(response, true)) {
      setDatas([]);
      setTotalData([]);
      searching(false);
      return;
    }

    if (!response.trmSumSheetList || response.trmSumSheetList.length === 0) {
      setDatas([]);
      setTotalData([]);
    } else {
      setDatas(response.trmSumSheetList.slice(0, -1));
      setTotalData(response.trmSumSheetList.slice(-1));
    }
    searching(false);
  };

  const handleClickSearch = (condition) => {
    setParam(condition);
  };

  const handleClickDownMonth = async () => {
    const { url } = API.DOWNMONTH;

    await props.downExcel.request(url, param);
  };

  const handleClickDown = async () => {
    const { url } = API.DOWN;

    await props.downExcel.request(url, param);
  };
  return (
    <div className="TrmSumSheet">
      <TrmSumSheetConditionBox onClickSearch={handleClickSearch} {...props} />
      <ControlBox>
        <Button className="withdrawl_rquest" onClick={handleClickDownMonth}>
          월집계표 다운로드
        </Button>
        <Button className="excel" onClick={handleClickDown}>
          엑셀 다운로드
        </Button>
      </ControlBox>
      <TrmSumSheetTable
        datas={datas}
        totalData={totalData}
        formatter={props.formatter}
      />
    </div>
  );
};

TrmSumSheet.propTypes = {};

export default withBase(TrmSumSheet);
